<template lang="pug">
div
  template(v-if="version === 'yc'")
    .d-flex.align-center
      template(v-if="changePageSize")
        .text-xs.basic600--text {{ ycText }}
        .ml-2.mr-4(style="width: 65px")
          v-select.text-xs.page-size(v-model="itemsPerPage" outlined dense :attach="attach" :items="pageSizes" hide-selected hide-details :menu-props="{ top: menuTop }")
            template(v-slot:append)
              eva-icon(name="chevron-down-outline" width="20" height="20" style="margin-top: 2px" :fill="$colors.basic700")
        v-spacer
      div
        v-btn.rounded-l(:class="{ primary500: page !== 1, primary300: page === 1 }" tile icon height="32" width="32" @click="page--" :disabled="page === 1")
          eva-icon(style="padding-top: 4px; padding-right: 2px;" name="arrow-ios-back-outline" height="17" :fill="$colors.basic100")
      .pl-3
        div(:style="`width: ${boxWidth}px`")
          v-select.text-xs.page-current(v-model="page" outlined dense :attach="attach" :items="pages" hide-details append-icon="" :menu-props="{ top: menuTop }")
            template(v-slot:selection="{ item }")
              .d-flex.justify-center(style="width: 100%;")
                .text-center {{ item }} / {{ totalPages }}
      .pl-3
        v-btn.rounded-r(:class="{ primary500: page !== totalPages, primary300: page === totalPages }" tile icon height="32" width="32" @click="page++" :disabled="page === totalPages")
          eva-icon(style="padding-top: 4px; padding-right: 2px;" name="arrow-ios-forward-outline" height="17" :fill="$colors.basic100")
  template(v-else)
    .d-flex.align-center(style="gap: 12px; width: 100%;")
      template(v-if="changePageSize")
        div.text-xs.neutral700--text Show item:
        div(style="width: 54px;")
          v-select.text-xs.round-md.page-size(v-model="itemsPerPage" :items="pageSizes" append-icon="$yzi-chevron-down" :menu-props="{ top: true, offsetY: true, rounded: 'lg', dense: true }" outlined dense hide-details)
      v-spacer
      template(v-if="showText")
        div.text-xs.neutral700--text(v-if="type === 'page'") Page {{ value }} of {{ totalPages | displayNumber }} {{ text }}
        div.text-xs.neutral700--text(v-if="type === 'item'") {{ itemRange }} of {{ count }} {{ text }}
      template(v-if="arrow")
        div
          y-button(outlined color="neutral400" background-color="var(--v-neutral100)" prepend-icon="mdi-chevron-left" :icon-color="disablePrev ? 'neutral400' : 'neutral700'" icon-size="20" :disabled="disablePrev" unset-min-width size="xxs" button-class="px-0" width="28" @click="page--" :style="disablePrev ? 'opacity: 0.6' : ''")
        div
          y-button(outlined color="neutral400" background-color="var(--v-neutral100)" prepend-icon="mdi-chevron-right" :icon-color="disableNext ? 'neutral400' : 'neutral700'" icon-size="20" :disabled="disableNext" unset-min-width size="xxs" button-class="px-0" width="28" @click="page++" :style="disableNext ? 'opacity: 0.6' : ''")
      template(v-else)
        div
          y-button(label="Back" color="neutral400" outlined background-color="var(--v-neutral100)" :text-color="disablePrev ? 'neutral400' : 'neutral700'" :disabled="disablePrev" unset-min-width size="xxs" height="24" button-class="px-2" @click="page--" :style="disablePrev ? 'opacity: 0.6' : ''")
        div
          y-button(label="Next" color="neutral400" outlined background-color="var(--v-neutral100)" :text-color="disableNext ? 'neutral400' : 'neutral700'" :disabled="disableNext" unset-min-width size="xxs" height="24" button-class="px-2" @click="page++" :style="disableNext ? 'opacity: 0.6' : ''")
</template>

<script>
export default {
  props: {
    value: {
      required: true
    },
    pageSize: {
      required: true
    },
    count: {
      required: true
    },
    type: {
      type: String,
      default: null // [page, item]
    },
    text: {
      type: String,
      default: null
    },
    ycText: {
      type: String,
      default: 'items per page'
    },
    attach: {
      type: Boolean,
      default: false
    },
    menuTop: {
      type: Boolean,
      default: false
    },
    arrow: {
      type: Boolean,
      default: false
    },
    changePageSize: {
      type: Boolean,
      default: false
    },
    version: {
      type: String,
      default: 'yz' // [yz, yc]
    }
  },
  data() {
    return {
      page: this.value || 36,
      pageSizes: [1, 5, 10, 20]
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.count / this.itemsPerPage) || 1
    },
    itemsPerPage: {
      get() {
        return this.pageSize
      },
      set(newValue) {
        this.$emit('update:pageSize', newValue)
        this.$emit('page-size-changed', newValue)
      }
    },
    pages() {
      let data = []
      for (let i = 1; i <= this.totalPages; i++) {
        data.push(i)
      }
      return data
    },
    showText() {
      return this.type
    },
    itemRange() {
      let endCount = Number(this.page) * Number(this.itemsPerPage)
      let startCount = endCount - Number(this.itemsPerPage) + 1
      if (this.page === this.totalPages) {
        endCount = this.count
      }
      let text = `${startCount} - ${endCount}`
      if (startCount === endCount) {
        text = startCount
      }
      return text
    },
    boxWidth() {
      let width = 65
      if (this.totalPages && this.totalPages.toString() && this.totalPages.toString().length > 2) {
        width += (this.totalPages.toString().length - 2) * 15
      }
      return width
    },
    disablePrev() {
      return this.page === 1
    },
    disableNext() {
      return this.page === this.totalPages
    }
  },
  watch: {
    value(val) {
      this.page = val
    },
    page(val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
  margin-top: 4px;
  height: 38px;
}

.primary500 {
  background-color: var(--v-primary500) !important;
}

.primary300 {
  background-color: var(--v-primary300) !important;
}

::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-primary200);
      margin-top: 4px;
      height: 38px;
    }
  }

  .page-size {
    .v-input__control {
      .v-input__slot {
        min-height: 30px !important;
        padding: 0 6px 0 8px !important;

        fieldset {
          height: 30px;
        }

        .v-select__slot {
          height: 30px;

          .v-input__append-inner {
            margin-top: 4px;

            .v-input__icon {
              min-width: 16px;
              width: 16px;

              .v-icon__component {
                height: 16px;
                width: 16px;
              }
            }
          }
        }
      }
    }
  }

  .page-current > .v-input__control > .v-input__slot {
    padding: 0 8px 0 8px !important;
  }
}
</style>
